"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _vars = require("@devsta/ui-kit/dist/common/styles/vars");

require("../styles/_upload.scss");

var ERROR_STATUS = "error";

function getColourFromUploadStatus(uploadStatus) {
  return uploadStatus === ERROR_STATUS ? _vars.COLOURS.red.alizarinCrimson : _vars.COLOURS.cyan.monkey;
}

function Upload(_ref) {
  var loadedPercent = _ref.loadedPercent,
      uploadStatus = _ref.uploadStatus,
      _useState = (0, _react.useState)({
    hasLoaded: 100 === loadedPercent
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hasLoaded = _useState2[0].hasLoaded,
      setLoaded = _useState2[1];

  if (void 0 === loadedPercent || hasLoaded) return null;
  100 === loadedPercent && setTimeout(function () {
    setLoaded({
      hasLoaded: !0
    });
  }, 500);
  var uploadText = 100 === loadedPercent ? "Uploaded" : "Uploading...";
  return _react["default"].createElement("div", {
    className: "upload"
  }, _react["default"].createElement("div", {
    className: "upload__text"
  }, _react["default"].createElement("h3", null, "".concat(loadedPercent, "%")), _react["default"].createElement("p", null, uploadStatus === ERROR_STATUS ? "Error" : uploadText)), _react["default"].createElement("div", {
    className: "upload__bar",
    style: {
      width: "".concat(loadedPercent, "%"),
      background: getColourFromUploadStatus(uploadStatus)
    }
  }));
}

var _default = (0, _react.memo)(Upload);

exports["default"] = _default;